import { render, staticRenderFns } from "./ErrorTestB.vue?vue&type=template&id=11ad15c7&"
import script from "./ErrorTestB.vue?vue&type=script&lang=js&"
export * from "./ErrorTestB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/noblecare-backend.mindful-birthing.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ad15c7')) {
      api.createRecord('11ad15c7', component.options)
    } else {
      api.reload('11ad15c7', component.options)
    }
    module.hot.accept("./ErrorTestB.vue?vue&type=template&id=11ad15c7&", function () {
      api.rerender('11ad15c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error-log/components/ErrorTestB.vue"
export default component.exports